import {MutationTree} from "vuex";
import moment from 'moment';
import IWidget from "@/modules/Dashboard/ts/IWidget";

export const mutations: MutationTree<any> = {

    updateWidget(state: any, widget: IWidget) {

        let index = state.widgets.findIndex((w: IWidget) => {
            return w.name === widget.name;
        });

        let item = JSON.parse(JSON.stringify(state.widgets[index]));

        item.active = widget.active;
        item.config = widget.config;

        state.widgets.splice(index, 1, item);
    },

    setWidgetsConfig(state: any, configs: Array<IWidget>) {

        state.widgets = configs;
    },

    setPanelSizeStats(state: any, payload: any) {
        state.panelSizeStatsExpire = moment().add(4, 'hours');
        state.panelSizeStats = payload;
    },

    setProjectActivityStats(state: any, payload: any) {
        state.projectActivityStatsExpire = moment().add(1, 'hours');
        state.projectActivityStats = payload;
    },

    setStatusPredictions(state: any, payload: any) {
        state.statusPredictionsExpire = moment().add(1, 'hours');
        state.statusPredictions = payload;
    },

    setProjectActivityStatsForLastHour(state: any, payload: any) {
        state.projectActivityStatsForLastHourExpire = moment().add(15, 'minutes');
        state.projectActivityStatsForLastHour = payload;
    },

    setChurnChart(state: any, payload: any) {
        state.churnStatsExpire = moment().add(4, 'hours');
        state.churnStats = payload.data;
    },

    setTopProjects(state: any, payload: any) {
        state.topProjectsExpire = moment().add(4, 'hours');
        state.topProjects = payload.data.projects;
    },

    setBusinessRulesImpact(state: any, payload: Array<any>) {
        state.businessRulesImpact = payload;
    },

    setBusinessRulesImpactLoading(state: any, payload: boolean) {
        state.businessRulesImpactLoading = payload;
    },
};
